"use client";

import React from "react";
import { Button } from "../ui/button";
import { MessageSquare } from "lucide-react";
import { Comments } from "./Comments";

interface ToolboxCommentsProps {
  brandId: string;
  toolboxItemId: string;
  toolboxItemTitle: string;
}

export function ToolboxComments({ brandId, toolboxItemId, toolboxItemTitle }: ToolboxCommentsProps) {
  const [showComments, setShowComments] = React.useState(false);

  return (
    <div className="border-t mt-8 pt-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">Comments & Feedback</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setShowComments(!showComments)}
        >
          <MessageSquare className="w-4 h-4 mr-2" />
          {showComments ? 'Hide Comments' : 'Show Comments'}
        </Button>
      </div>
      
      {showComments && (
        <Comments
          brandId={brandId}
          targetType="toolbox_item"
          targetId={toolboxItemId}
          title={`${toolboxItemTitle} Comments`}
        />
      )}
    </div>
  );
}